import React from 'react';
import { Alert, Button, Box } from '@mui/material';

const ErrorMessage = ({ error, onRetry }) => {
    if (!error) return null;

    return (
        <Box sx={{ my: 2 }}>
            <Alert
                severity="error"
                action={
                    onRetry && (
                        <Button color="inherit" size="small" onClick={onRetry}>
                            Thử lại
                        </Button>
                    )
                }
            >
                {error}
            </Alert>
        </Box>
    );
};

export default ErrorMessage;
